import classNames from 'classnames';
import type Immutable from 'immutable';
import { bool, node, oneOfType, string } from 'prop-types';
import React, { Component } from 'react';
import { list } from 'react-immutable-proptypes';

import './select-wrapper.scss';
import AuthFormTooltipError from './tooltip-error';

class AuthFormSelectWrapper extends Component<{
  children?: React.ReactNode;
  error?: boolean | Immutable.List<any>;
  errorMessage?: string;
}> {
  static propTypes = {
    children: node,
    error: oneOfType([bool, list]),
    errorMessage: string,
  };

  state: { hasFocus: boolean; hasMouse?: boolean } = { hasFocus: false };

  onFocus = () => {
    this.setState({ hasFocus: true });
  };

  onBlur = () => {
    this.setState({ hasFocus: false });
  };

  onMouseEnter = () => {
    this.setState({ hasMouse: true });
  };

  onMouseLeave = () => {
    this.setState({ hasMouse: false });
  };

  render() {
    const { children, error, errorMessage } = this.props;
    const { hasFocus, hasMouse } = this.state;
    const showTooltip = error && (hasFocus || hasMouse);
    return (
      <div
        className={classNames(
          'AuthFormSelectWrapper',
          hasFocus && 'AuthFormSelectWrapper--focus',
          error && 'AuthFormSelectWrapper--invalid',
        )}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        data-auth-form-error={`${!!error}`}
      >
        {children}
        {showTooltip && (
          <AuthFormTooltipError error={error}>
            {errorMessage}
          </AuthFormTooltipError>
        )}
      </div>
    );
  }
}

export default AuthFormSelectWrapper;
